import { useState, useEffect, useRef } from "react";
import {
  FiltroCascadaScrollContainer,
  ModalPreparacionBody,
  ModalPreparacionBtn,
  ModalPreparacionBtnCerrar,
  ModalPreparacionContainer,
  ModalPreparacionFooter,
  ModalPreparacionSubBody,
  ScrollDownButton,
  ScrollUpButton,
} from "./localStyle";
import Flecha from "./assets/Fecha";
import EtiquetaAzulBusqueda from "../EtiquetaAzulBusqueda/EtiquetaAzulBusqueda";

const ModalPreparacion = ({
  data,
  dismiss,
  buscar,
  onClickBuscar,
  prestacion,
  fullStr,
}) => {
  //#region --------- context ---------------
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const [contador, setContador] = useState(3);
  const dtoPrestacion = { GruposMedico: [prestacion] };
  const containerRef = useRef(null);
  const [activateScroll, setActivateScroll] = useState(false);
  const [scrollInterval, setScrollInterval] = useState(null);
  const requiereAutorizacionTxt =
    "Su turno requiere autorizacion de su cobertura médica";
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const onMouseDownUp = (direction) => {
    const scroll = () => {
      if (containerRef.current) {
        containerRef.current.scrollTo({
          top: containerRef.current.scrollTop + (direction === "up" ? -48 : 48),
          behavior: "smooth",
        });
      }
    };
    setScrollInterval(setInterval(scroll, 100));
  };

  const onMouseUp = () => {
    clearInterval(scrollInterval);
  };

  const onClickUp = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollTop - 48,
        behavior: "smooth",
      });
    }
  };

  const onClickDown = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollTop + 48,
        behavior: "smooth",
      });
    }
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    const timer = setTimeout(() => {
      if (contador > 0) {
        setContador(contador - 1);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [contador]);

  const handleCerrar = () => {
    if (contador === 0) {
      dismiss();
    }
  };
  useEffect(() => {
    if (containerRef.current) {
      const height = containerRef.current.clientHeight;
      if (height > 368) {
        setActivateScroll(true);
      } else {
        setActivateScroll(false);
      }
    }
  }, [data.preparacion]);
  //#endregion  -------- useEffect ---------------

  return (
    <ModalPreparacionContainer>
      <ModalPreparacionBody>
        {prestacion && (
          <EtiquetaAzulBusqueda
            fullStr={fullStr}
            dtoPrestacion={dtoPrestacion}
          />
        )}
        {data.requiereAutorizacion && (
          <div className="EtiquetaAutorizacion">
            <span>Requiere autorización</span>
          </div>
        )}
        <ModalPreparacionSubBody>
          <div
            className="ModalPreparacion-txtPreparacion"
            scroll={activateScroll}
            ref={containerRef}
            dangerouslySetInnerHTML={{ __html: data.preparacion }}
          ></div>
          {activateScroll && (
            <FiltroCascadaScrollContainer>
              <ScrollUpButton
                onClick={onClickUp}
                onMouseDown={() => onMouseDownUp("up")}
                onMouseUp={onMouseUp}
                onMouseLeave={onMouseUp}
              >
                <Flecha />
              </ScrollUpButton>
              <ScrollDownButton
                onClick={onClickDown}
                onMouseDown={() => onMouseDownUp("down")}
                onMouseUp={onMouseUp}
                onMouseLeave={onMouseUp}
              >
                <Flecha />
              </ScrollDownButton>
            </FiltroCascadaScrollContainer>
          )}
        </ModalPreparacionSubBody>
      </ModalPreparacionBody>
      <ModalPreparacionFooter>
        <ModalPreparacionBtnCerrar
          onClick={contador > 0 ? () => {} : handleCerrar}
          cerrar={contador > 0}
        >
          {contador > 0 ? `(${contador})s` : "Cerrar"}
        </ModalPreparacionBtnCerrar>
        {buscar && (
          <ModalPreparacionBtn
            onClick={contador > 0 ? () => {} : onClickBuscar}
            cerrar={contador > 0}
          >
            {contador > 0 ? `(${contador})s` : "Buscar turno"}
          </ModalPreparacionBtn>
        )}
      </ModalPreparacionFooter>
    </ModalPreparacionContainer>
  );
};

export default ModalPreparacion;
